import Modal from '@storeblocks/modal';
import React, { ReactElement, useEffect, useState } from 'react';

import { useProfileV3 } from 'Api/profile';
import { linkPath } from 'Utils/navigation.utils';
import { getAppText } from 'Utils/text';
import {
  getAkaConsentSeenInLast6Months,
  setAkaConsentModalLastSeenToday,
} from './akaConsentModal.helpers';
import { ContentContainer } from './akaConsentModal.styles';

export const AkaConsentModal = (): ReactElement => {
  const [open, setOpen] = useState(false);
  const { data, loading, error } = useProfileV3();

  useEffect(() => {
    const seenInLast6Months = getAkaConsentSeenInLast6Months();
    const akaConsent = data?.consents.unionSolicitation;
    const showAkaConsentPopup =
      !loading && !error && (!seenInLast6Months || akaConsent == null);

    if (showAkaConsentPopup) {
      setOpen(true);
      setAkaConsentModalLastSeenToday();
    }
  }, [data, loading, error]);

  const closeModal = (): void => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      heading={
        <>
          <h3>{getAppText('akaConsent.modal.title')}</h3>
          <p>{getAppText('akaConsent.modal.description')}</p>
        </>
      }
      content={
        <ContentContainer>
          <iframe
            seamless
            title="Samtykke til digitalt kundeforhold"
            src={linkPath('/kundeprofil/webview/fagforening')}
          />
        </ContentContainer>
      }
      onClose={closeModal}
      footer={null}
      trigger={null}
    />
  );
};
